import { styled, css } from 'styled-components';
import { colors } from '../../../abstracts/colors';
import { dontForwardProps } from '../../../util';
export const typesColors = {
  success: {
    backgroundColor: colors.successBright,
    color: colors.black
  },
  warn: {
    backgroundColor: colors.warningBright,
    color: colors.black
  },
  error: {
    backgroundColor: colors.errorDeep,
    color: colors.white
  },
  dark: {
    backgroundColor: colors.black,
    color: colors.white
  },
  default: {
    backgroundColor: colors.neutralBrightest,
    color: colors.black
  }
};
const bannerStylesByType = type => css(["background-color:", ";color:", ";"], typesColors[type].backgroundColor, typesColors[type].color);
export const AlertBannerContainer = styled.div.withConfig(dontForwardProps()).withConfig({
  displayName: "AlertBannerContainer",
  componentId: "asurion-ui-react__sc-vkkqwn-0"
})(["background-color:#e6e6eb;display:", ";box-sizing:border-box;flex-direction:column;align-items:flex-end;width:100%;", ";"], ({
  isOpen
}) => isOpen ? 'flex' : 'none', ({
  alertBannerType
}) => bannerStylesByType(alertBannerType));